import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetSpecialAgentCommision, callDeleteSpecialAgentCommision, callApproveRejectedSpecialAgentCommision } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { convertStringToJson, displayUrl, handleGetCookie } from "../../../utils/commonUtil";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
import colors from '../../../utils/colors';
import moment from "moment";
import statusItems from "../../../data/agentSpecial"
import { Modal } from 'react-bootstrap';
import { openDocumentPreview } from "../../../components/document-preview";
import SmartTable from "../../../components/common/table-component";

const SpecialAgentCommision = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', updateBy: '', status: '0', reason: '', id: null, agentCode: '' });
	const [specialAgentList, setSpecialAgentList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [showReason, setShowReason] = useState(false);

	useEffect(() => {
		loadData();
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				updateBy: authData?.user?.userId,
				updateName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, status: request.status };
		const rsp = await dispatch(callGetSpecialAgentCommision(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setSpecialAgentList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords);
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault();
		loadData();
	};

	const handleClose = () => {
		setShowReason(false)
	}

	const handleApprovedRejected = (item, status) => {
		setShowReason(true)
		setRequest((prev) => ({
			...prev,
			status,
			id: item.id,
			agentCode: item.agentCode
		}));
	};

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	const handleChangeReason = (e) => {
		setRequest((prev) => ({ ...prev, reason: e.target.value }));
	};

	const handleSave = (e) => {
		e.preventDefault();
		Swal.fire({
			title: t("confirm"),
			text: (request.status === 1 ? t("settings.agentSpecialCommission.approvedTitle") : t("settings.agentSpecialCommission.rejectedTitle")) + " ?",
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				let data = {
					id: request.id,
					status: request.status,
					reason: request.reason,
					updateBy: request.updateBy
				}
				const rsp = await dispatch(callApproveRejectedSpecialAgentCommision(data));
				if (rsp?.payload?.responseCode === "00000") {
					Swal.fire({
						icon: "success",
						title: request.status == 1 ? t("success.approvedSpecialCommission") : t("success.rejectSpecialCommission"),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t('close'),
					}).then(() => {
						window.location.reload()
					});
				}
			}
		});
	}

	const handleOpenFile = (file) => {
		if (file) openDocumentPreview(file);
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.approved.commissionAgent")}</h4>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
														/>
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															statusItems.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "settings.agentSpecialCommission.id", key: "id" },
							{ labelKey: "settings.agentSpecialCommission.agentCode", key: "agentCode", render: (val, row) => <button className="btn btn-link" onClick={() => handleOpenFile(convertStringToJson(row.documentPath))}>{val || '-'}</button> },
							{ labelKey: "settings.agentSpecialCommission.firstName", key: "firstName" },
							{ labelKey: "settings.agentSpecialCommission.lastName", key: "lastName" },
							{ labelKey: "settings.agentSpecialCommission.commission", key: "commissionRate" },
							{ labelKey: "settings.agentSpecialCommission.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.approved')}</span> : val === 0 ? <span className="badge bg-primary">{t('status.waiting')}</span> : <span className="badge bg-danger">{t('status.rejected')}</span> },
							{ labelKey: "settings.agentSpecialCommission.createdDate", key: "createdAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "settings.agentSpecialCommission.createdBy", key: "createdBy" },
						]}
	data={{ result: specialAgentList }}
	rowKey="id"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={false}
	actions={(item) => (<div>
							{item.status === 0 && <button className="btn btn-success btn-sm" onClick={() => handleApprovedRejected(item, 1)}><i className="fas fa-check"></i></button>}
							&nbsp;
							{item.status === 0 && <button className="btn btn-danger btn-sm" onClick={() => handleApprovedRejected(item, -1)}><i className="fas fa-ban"></i></button>}
						</div>)}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<Modal show={showReason} onHide={handleClose}>
						<Modal.Header closeButton>
							<Modal.Title>
								{
									request.status === 1 ?
										t("settings.agentSpecialCommission.approvedTitle") :
										t("settings.agentSpecialCommission.rejectedTitle")
								}
								{
									__t("uiText.text095") + request.agentCode
								}
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<form onSubmit={handleSave}>
								<div className="row">
									<div className="default-form">
										<div className="col-12 form-group">
											<label> {t('settings.agentSpecialCommission.reason')} <span className="text-danger">*</span> </label>
											<textarea
												name="reason"
												placeholder={t('settings.agentSpecialCommission.reason')}
												value={request.reason}
												onChange={handleChangeReason}
												required>
											</textarea>
										</div>
										<div className="col-12 d-flex justify-content-end">
											<button className="btn btn-success" type="submit">
												{t("button.save")}
											</button>
										</div>
									</div>
								</div>
							</form>
						</Modal.Body>
					</Modal>

				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default SpecialAgentCommision;
